import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Home from '../Home/Home';

const Payment = () => {
  const navigate = useNavigate();

  let formData = null;
  try {
    formData = JSON.parse(sessionStorage.getItem('updatedFormData'));
  } catch (err) {
    console.error('Invalid JSON in sessionStorage:', err);
  }

  useEffect(() => {
    if (!formData) return;

    const userId = formData.userId;
    const totalTicketPrice = formData.totalTicketPrice;
    const emailId = formData.email;
    const eventId = formData.eventId;

    const script = document.createElement('script');
    script.src = 'https://www.paypal.com/sdk/js?client-id=Acx4i_guUS5wP6bYiMs8RwrE_3WrKivBTIXPt4sBc89JsY_IQMBvy8LnA_tjX8myOx1yOlf797TXgy62&currency=USD';
    script.async = true;

    script.onload = () => {
      if (!window.paypal) {
        console.error('PayPal SDK failed to load.');
        return;
      }

      window.paypal.Buttons({
        style: {
          shape: 'rect',
          layout: 'vertical',
          color: 'gold',
          label: 'paypal',
        },

        async createOrder() {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/create/order`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                cart: [{ id: 'test-order-id', quantity: totalTicketPrice }],
                userId,
                emailId,
                eventId,
              }),
            });

            const orderData = await response.json();
            if (orderData.id) return orderData.id;

            const errorDetail = orderData?.details?.[0];
            const errorMessage = errorDetail
                ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                : JSON.stringify(orderData);

            throw new Error(errorMessage);
          } catch (error) {
            console.error('Order creation failed:', error);
            resultMessage(`Could not initiate PayPal Checkout.<br><br>${error}`);
          }
        },

        async onApprove(data, actions) {
          try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/payment/order/${data.orderID}/capture`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ userId }),
            });

            const orderData = await response.json();

            const errorDetail = orderData?.details?.[0];
            if (errorDetail?.issue === 'INSTRUMENT_DECLINED') {
              return actions.restart();
            } else if (errorDetail) {
              throw new Error(`${errorDetail.description} (${orderData.debug_id})`);
            } else if (!orderData.purchase_units) {
              throw new Error(JSON.stringify(orderData));
            } else {
              const transaction =
                  orderData?.purchase_units?.[0]?.payments?.captures?.[0] ||
                  orderData?.purchase_units?.[0]?.payments?.authorizations?.[0];

              resultMessage(`Transaction ${transaction.status}: ${transaction.id}<br><br>Check console for details.`);
              console.log('Capture result:', orderData);

              if (orderData.status === 'COMPLETED') {
                localStorage.setItem('paypal-order-id', orderData.id);
                localStorage.setItem('paypal-status', orderData.status);
                navigate('/payment-success');
              }
            }
          } catch (error) {
            console.error('Payment approval failed:', error);
            resultMessage(`Transaction could not be processed.<br><br>${error}`);
          }
        },
      }).render('#paypal-button-container');
    };

    script.onerror = () => {
      console.error('PayPal script failed to load.');
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [formData, navigate]);

  const resultMessage = (message) => {
    const container = document.getElementById('result-message');
    if (container) {
      container.innerHTML = message;
    }
  };

  if (!formData) {
    navigate('/');
    return null;
  }

  return (
      <Home>
        <div className="container">
          <h2>Complete Your Payment</h2>
          <div id="paypal-button-container" />
          <div id="result-message" style={{ marginTop: '20px', color: 'green' }} />
        </div>
      </Home>
  );
};

export default Payment;